module.exports = __webpack_public_path__ + "static/social-share-4ff0ea332d12b0b429971cf11f821b8e.jpg";